// Testimonials — keep empty until you have real ones. The home section
// auto-hides when this array is empty.
//
// Add real quotes only. Never invent. Format:
//   {
//     quote: "It just works, day one.",
//     name: "Priya S.",
//     role: "Freelance writer",
//     product: "ai-writing-kit", // optional
//   }
export const testimonials = [];
